module.exports = __webpack_public_path__ + "img/blockS3-card6.f9cdbe9d.jpg";